var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
// Implementation taken from here: https://github.com/mui-org/material-ui/blob/next/packages/material-ui/src/utils/useId.js#L6
export var useId = function (idOverride) {
    var _a = __read(React.useState(idOverride), 2), defaultId = _a[0], setDefaultId = _a[1];
    var id = idOverride || defaultId;
    React.useEffect(function () {
        var _a;
        if (defaultId == null) {
            if (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) === 'test') {
                setDefaultId("quantum-product-mocked");
            }
            else {
                // Fallback to this default id when possible.
                // Use the random value for client-side rendering only.
                // We can't use it server-side.
                setDefaultId("quantum-product-".concat(Math.round(Math.random() * 1e5)));
            }
        }
    }, [defaultId]);
    return id;
};
